// Unified search scan service - routes to the correct platform scanner
// Analogous to propertyService.js for property fetching

import { detectSearchPlatform, PLATFORMS } from '../utils/propertyPlatforms';
import { scanBazarakiSearch } from './bazarakiSearchScanner';
import { scanBuySellSearch } from './buysellSearchScanner';
import { scanDomComSearch } from './domcomSearchScanner';

/**
 * Scan a search URL for property listings.
 * Automatically detects the platform and delegates to the appropriate scanner.
 *
 * @param {string} searchUrl - Search URL from any supported platform
 * @returns {Promise<Array<{id: string, title: string, price: number|string, url: string}>>}
 * @throws {Error} If the URL is not from a supported platform
 */
export const scanSearch = async (searchUrl) => {
  const platform = detectSearchPlatform(searchUrl);

  if (!platform) {
    throw new Error(
      'Unsupported search URL. Supported platforms: Bazaraki, BuySell Cyprus, DOM.com.cy.'
    );
  }

  switch (platform) {
    case PLATFORMS.BAZARAKI:
      return await scanBazarakiSearch(searchUrl);

    case PLATFORMS.BUYSELL:
      return await scanBuySellSearch(searchUrl);

    case PLATFORMS.DOMCOM:
      return await scanDomComSearch(searchUrl);

    default:
      throw new Error(`Search scanning not yet supported for platform: ${platform}`);
  }
};
